import { useState, useEffect } from 'react';
import { uploadFile } from '../services/api/virtualAssistant'; 

// Define types and interfaces
interface Setting {
    Id: string;
    Name: string;
    ConfigValue: string;
}

type SettingId = 'background_color' | 'font_color' | 'icon_color' | 'header_color' | 'show_header';

export const useUISettings = (assistant: { app_id?: string, app_ui_settings?: any } = {}) => {
    const [bgColor, setBgColor] = useState<string>(assistant?.app_ui_settings?.background_color || '#FFFFFF');
    const [fontColor, setFontColor] = useState<string>(assistant?.app_ui_settings?.font_color || '#0d0d0d');
    const [iconColor, setIconColor] = useState<string>(assistant?.app_ui_settings?.icon_color || '#5E5E5E');
    const [headerColor, setHeaderColor] = useState<string>(assistant?.app_ui_settings?.header_color || '#FFFFFF');
    const [logo, setLogo] = useState<string>(assistant?.app_ui_settings?.ui_logo || '');
    const [isShowHeader, setIsShowHeader] = useState<boolean>(assistant?.app_ui_settings?.show_header || true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const getCachedData = (key: string) => {
            const item = sessionStorage.getItem(key);
            if (!item) return null;
            const { value, timestamp } = JSON.parse(item);
            if (Date.now() - timestamp > 2 * 24 * 60 * 60 * 1000) { // 2 days cache
                sessionStorage.removeItem(key);
                return null;
            }
            return value;
        };

        const config = getCachedData('systemConfig');
        if (config) {
            let KaiBlobLocation =config.find((item: Setting) => item.Id === 'blob_root_folder')?.ConfigValue;
            const defaultHeaderLogo = KaiBlobLocation + "/logo/headerlogodefault.png";
            setLogo(defaultHeaderLogo)
            const uiSettings = config.find((item: Setting) => item.Id === 'ui_settings')?.ConfigValue;
            if (uiSettings) {
                // console.log(uiSettings)
                applySettings( uiSettings);
            }
        }
    }, [assistant.app_id]);

    const getNetId = () => {
        return localStorage.getItem('netId');
    };

    const applySettings = (settings: Setting[]) => {
        const settingsMap: Record<SettingId, Function> = {
            background_color: setBgColor,
            font_color: setFontColor,
            icon_color: setIconColor,
            header_color: setHeaderColor,
            show_header: setIsShowHeader,
        };

        settings.forEach((setting) => {
            const setterFunction = settingsMap[setting.Id as SettingId];
            if (setterFunction) {
                if (setting.Id === 'show_header') {
                    setterFunction(setting.ConfigValue === 'true');
                } else {
                    setterFunction(setting.ConfigValue || 'default_value');
                }
            }
        });
        
    };

    return {
        bgColor,
        setBgColor,
        fontColor,
        setFontColor,
        iconColor,
        setIconColor,
        headerColor,
        setHeaderColor,
        logo,
        setLogo,
        isShowHeader,
        setIsShowHeader,
        error,
    };
};
